<template>
  <div style="text-align: center;">
    
    <template v-if="wishBetMsg.data.type === 'message'">
      <div class="dialog_text">
        <p v-html="wishBetMsg.data.content"></p>
      </div>
      <button class="v-btn primary-btn" style="margin-left: 0px" @click="closeDialog()">
        <span >{{ $t('WishBets.CloseDialog') }}</span>
      </button>
    </template>

    <template v-if="wishBetMsg.data.type === 'barcode'">
      <div class="dialog_header">
        <span class="header_text">{{ $t('WishBet.BarcodeInfo') }}</span>
        <v-icon class="close" @click="closeBarCodeDialog()">close</v-icon>
      </div>
      <div class="dialog_text">
        <vue-barcode :value="wishBetMsg.data.content" format="ITF14"></vue-barcode>
      </div>
    </template>

    <template v-if="wishBetMsg.data.type === 'confirmation_popup'">
      <div class="dialog_text">
        <p v-html="$t('WishBet.DeleteBetDesc')"></p>
      </div>
      <button class="v-btn secondary-btn" style="margin-left: 0px" @click="closeDialog()">
        <span >{{ $t('WishBets.No') }}</span>
      </button>
      <button class="v-btn primary-btn" style="margin-left: 0px" @click="deleteWishBet()">
        <span >{{ $t('WishBets.Yes') }}</span>
      </button>
    </template>

    <template v-if="wishBetMsg.data.type === 'checkbet'">
      <div class="dialog_preheader" :class="ticketStatusFormated"></div>
      <div class="dialog_header">
        <h3>{{ $t('WishBet.TicketInfo')}}</h3>
        <v-icon class="close" @click="closeDialog()">close</v-icon>
      </div>
      <div v-if="scannedTicketError" class="dialog_text error_msg">
        <span> {{scannedTicketError}} </span>
      </div>
      <div v-if="!scannedTicketError" class="dialog_text">
        <div class="ticket_status_icon" :class="ticketStatusFormated">
        </div>
        <div class="ticket_status" :class="ticketStatusFormated">
          {{ $t('WishBet.TicketInfo.Status' + ticketStatusFormated) }}
        </div>
        <div class="ticket_desc">
           <h3 v-if="scannedTicket.payoutAmount && ticketStatusFormated === 'Unpaid'" class="payout_amount">
            {{ $t('WishBet.TicketInfo.PayoutAmount') }} 
            <span class="amount">{{scannedTicket.currency}} {{ payoutAmountFormated }}</span>
          </h3>
          {{ $t('WishBet.TicketInfo.Status' + ticketStatusFormated + 'Desc') }}
        </div>
        <div class="ticket_info">
          <span class="line"><span class="label">{{ $t('WishBet.TicketInfo.TicketId') }}</span> #{{scannedTicket.ticketId}}</span>
          <span class="line"><span class="label">{{ $t('WishBet.TicketInfo.Date') }} </span>
            <span>{{scannedTicket.placementTime | moment(dateFormats.longDate)}}</span>
            <span>{{scannedTicket.placementTime | moment(dateFormats.longTime)}}</span>
          </span>
        </div>
        <!-- {{scannedTicket}} -->
      </div>
      </template>

  </div>
</template>

<script>
  //  import Vue from 'vue'
  import store from '@/store'
  import config from '@/config'
  import VueBarcode from 'vue-barcode'

  export default {
    name: 'wish-bet-msg-dialog',

    data () {
      return {
      }
    },
    components: {
      VueBarcode
    },

    computed: {
      dateFormats () {
        return config.app.dateFormats
      },
      wishBetMsg () {
        return store.getters['overlayState/getWishBetMsgDialogState']
      },
      scannedTicket () {
        return store.getters['wishBets/getTicketInfo']
      },
      scannedTicketError () {
        return store.getters['wishBets/getTicketInfoError']
      },
      ticketStatusFormated () {
        if (this.scannedTicket) {
          let ticket = this.scannedTicket.ticketState
          var ticketStatus
          switch (ticket) {
            case 'O':
              ticketStatus = 'Open'
              break
            case 'C':
              ticketStatus = 'Closed'
              break
            case 'F':
              ticketStatus = 'Failed'
              break
            case 'U':
              ticketStatus = 'Unpaid'
              break
            case 'l':
              ticketStatus = 'Loser'
              break
            case 'c':
              ticketStatus = 'Claimed'
              break
            case 'e':
              ticketStatus = 'Expired'
              break
            case 'x':
              ticketStatus = 'Canceled'
              break
            case 'b':
              ticketStatus = 'Blocked'
              break
            case 'N':
              ticketStatus = 'Undetermined'
              break
            default:
              ticketStatus = ''
          }
          return ticketStatus
        } else {
          return ''
        }
      },
      payoutAmountFormated () {
        return this.scannedTicket.payoutAmount ? this.scannedTicket.payoutAmount.toLocaleString(this.dateFormats.locale) : this.scannedTicket.payoutAmount
      }
    },

    methods: {
      closeDialog () {
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
      },
      closeBarCodeDialog () {
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
        if (this.$route.name !== 'savedbets') {
          this.$router.push({name: 'savedbets'})
        }
        store.dispatch('overlayState/deactivateBetslip')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      deleteWishBet () {
        // console.log('deleteWishBet')
        store.dispatch('wishBets/deleteWishBet', this.wishBetMsg.data.content)
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
      }
    },

    created () {

    },

    watch: {

    },

    destroyed () {
    }
  }
</script>

<style lang="stylus" scoped>
.dialog_preheader
  height 20px
  background #DCDFE7
  margin -15px -15px 10px -15px
  &.Unpaid
  &.Win
    background #10AF29
  &.Open
    background #DCDFE7
  &.Lost
  &.Loser
    background #DA222D
  &.Failed
  &.Undetermined
  &.Closed
  &.Blocked
  &.Canceled
  &.Paid
  &.Expired
  &.Claimed
    background #FFA200
.dialog_header
  display flex
  justify-content: space-between
  padding-bottom 20px
  align-items center
  h3 
    text-align center
    flex-grow 1
    margin 0
    font-size 24px
    font-family: 'Roboto Condensed Bold'
  .header_text
    text-align left
    font-size 14px
    font-family: 'Roboto Condensed Bold'
    padding-right 10px
  .v-icon
    color #003764
    font-size 30px
    margin-right -15px
    margin-top -10px
    margin-bottom auto
.dialog_text p
  font-size 14px
  font-family 'Roboto Condensed'
  padding 10px 0
.error_msg
  padding-bottom 20px
  font-size 14px
.ticket_info
  padding: 20px 0
  text-align left
  font-size 14px
  .line
    display block
    padding 1px 0
    font-family 'Roboto Condensed'
    .label
      font-family 'Roboto Condensed Bold'
.payout_amount
  margin 0
  padding 10px
  background #fff
  border 1px solid #8B8B8B
  width 280px
  height 40px
  border-radius 5px
  font-size 16px
  margin 0 auto 10px auto
  line-height 15px
  .amount
    font-size 16px
    padding-left 5px
.ticket_desc
  padding 20px 0
  font-size 16px
  background #BDC4D8
  font-family 'Roboto Condensed'
  margin 5px -15px 0 -15px
.ticket_status
  font-size 20px
  font-family 'Roboto Condensed Bold'
.ticket_status_icon
  height 52px
  width 51px
  display block
  margin 0 auto 20px auto
  background-repeat: no-repeat
  background-size: 100% !important
  &.Unpaid
  &.Win
    background url('~@/assets/images/wishBet/checkbet_won.svg')
  &.Open
    background url('~@/assets/images/wishBet/checkbet_open.svg')
  &.Lost
  &.Loser
    background url('~@/assets/images/wishBet/checkbet_lost.svg')
  &.Failed
  &.Undetermined
  &.Closed
  &.Blocked
  &.Canceled
  &.Paid
  &.Expired
  &.Claimed
    background url('~@/assets/images/wishBet/checkbet_info_orange.svg')
</style>



// WEBPACK FOOTER //
// src/components/common/wishBetMsgDialog.vue